import * as angular from "angular";
import {IController} from "angular";

export class bringozTimeWindowTooltipCtrl implements IController {

  notBefore: any;
  notAfter: any;
  timeZoneId: string;
  configZoneId: string;

  private timeZoneOffsetDiff: number;

  /* @ngInject */
  constructor(private splitService) {}

  $onInit() {
    this.checkTimeZoneOffsetDiff();
  }

  $onChanges(changes) {
    if (changes.notBefore && !changes.notBefore.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }

    if (changes.notAfter && !changes.notAfter.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }

    if (changes.configZoneId && !changes.configZoneId.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }
  }

  checkTimeZoneOffsetDiff() {
    this.timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(this.timeZoneId, this.notBefore);
    return this.timeZoneOffsetDiff !== 0;
  }

}
angular
  .module('bringoz.admin.commons')
  .component('bringozTimeWindowTooltip', {
    bindings: {
      notBefore: '<',
      notAfter: '<',
      timeZoneId: '<',
      configZoneId: '<'
    },
    template: require('./bringoz-time-window-tooltip.html').default,
    controller: bringozTimeWindowTooltipCtrl
  });
